// extracted by mini-css-extract-plugin
export default {"upload_wrapper":"styles_upload_wrapper__Yvy5B"};